import { createAction } from '@reduxjs/toolkit';
import { Check } from '../types/check/types';

export const INITIALIZE_STORE_STATE = '@INITIALIZE_STORE_STATE';

/**
 * Initialize store state action creator.
 * Action has as payload fetched check with which store state has to be initialized.
 */
export const initStoreState = createAction<Check>(INITIALIZE_STORE_STATE);
